import React from 'react';
import { Sidebar } from './Sidebar';
import { Search, Bell, User } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onLogout: () => void;
}
export function Layout({
  children,
  activeTab,
  setActiveTab,
  onLogout
}: LayoutProps) {
  return <div className="flex min-h-screen bg-gray-50" data-id="element-23">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={onLogout} data-id="element-24" />

      <div className="flex-1 ml-64 flex flex-col min-h-screen" data-id="element-25">
        <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-end px-8 sticky top-0 z-10" data-id="element-26">
          <div className="flex items-center gap-4" data-id="element-27">
            <button className="p-2 text-gray-500 hover:bg-gray-50 rounded-lg transition-colors relative" data-id="element-28">
              <Bell size={20} data-id="element-29" />
              <span className="absolute top-2 right-2 w-2 h-2 bg-indigo-600 rounded-full border-2 border-white" data-id="element-30"></span>
            </button>
            <div className="h-8 w-[1px] bg-gray-200 mx-2" data-id="element-31"></div>
            <div className="flex items-center gap-3 pl-2" data-id="element-32">
              <div className="text-right" data-id="element-33">
                <p className="text-sm font-semibold text-slate-900" data-id="element-34">
                  Alex Thompson
                </p>
                <p className="text-xs text-gray-500" data-id="element-35">Elite Partner</p>
              </div>
              <div className="w-10 h-10 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-slate-600" data-id="element-36">
                <User size={20} data-id="element-37" />
              </div>
            </div>
          </div>
        </header>

        <main className="flex-1 p-8 overflow-y-auto bg-gray-50" data-id="element-38">
          {children}
        </main>
      </div>
    </div>;
}